import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  ActivityIndicator,
  Modal,
  Platform,
  FlatList,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useEffect, useState } from "react";
import { TextInput } from "react-native";
import Colours from "../../utils/Colours";
import * as ImagePicker from "expo-image-picker";
import * as FileSystem from "expo-file-system/legacy";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import ViewMoreIcon from "../../icons/ViewMoreIcon";
import PublicProfile from "../publicProfile/PublicProfile";
import { ScrollView } from "react-native-gesture-handler";
import BackArrow from "../../icons/BackArrow";
import { CommonActions, useNavigation, useRoute } from "@react-navigation/native";
import axios from "../../api/axios";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import * as ImageManipulator from "expo-image-manipulator";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const MAX_IMAGE_SIZE_MB = 1;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MAX_IMAGES = 3;

const UserBioSettingUp = () => {
  const [isFormContainer1Clicked, setIsFormContainer1Clicked] = useState(false);
  const [isFormContainer2Clicked, setIsFormContainer2Clicked] = useState(false);
  const [isFormContainer3Clicked, setIsFormContainer3Clicked] = useState(false);
  const [isPhotoClicked, setIsPhotoClicked] = useState(false);
  const [isSocialAccountForm, setIsSocialAccountForm] = useState("");
  const [isBioBoxClicked, setIsBioBoxClicked] = useState(false);
  const [isUpdateClicked, setIsUpdateClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoadingx, setIsLoadingx] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);
  const [isLoading4, setIsLoading4] = useState([]);

  const [isLoadingBio, setIsLoadingBio] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isSuccessAlertCompVisible, setIsSuccessAlertCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // const [image, setImage] = useState(initialImage)
  const [images, setImages] = useState([]);
  const [word1, setWord1] = useState("");
  const [word2, setWord2] = useState("");
  const [word3, setWord3] = useState("");
  const [bio, setBio] = useState("");
  const [socialAccount, setSocialAccount] = useState("");

  const route = useRoute();

  let userDataObj_v3 = route.params.userDataObj_v3;
  const profilePhoto = userDataObj_v3.image;

  const navigate = useNavigation();

  useEffect(() => {
    ////console.log(images)
  }, [images]);

  const pickMultiImage = async (setImages, setIsLoading, currentImages) => {
    try {
      setIsLoading(true);

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: false,
        allowsMultipleSelection: true,
        aspect: [4, 4],
        quality: 1,
      });

      if (result.canceled) return;

      const newAssets = result.assets || [];
      const newImageURIs = [];

      for (let asset of newAssets) {
        const fileInfo = await FileSystem.getInfoAsync(asset.uri);
        const fileSizeInMB = fileInfo.size / (1024 * 1024);

        ////console.log(`Selected image size: ${fileSizeInMB.toFixed(2)} MB`);

        if (fileSizeInMB > 3) {
          setErrorMessage(
            `Image too large: The selected image is ${fileSizeInMB.toFixed(
              2,
            )} MB. Please choose one below 3MB.`,
          );
          setIsErrorCompVisible(true);
          //  setSelectedPhoto(false);
          setIsLoading(false);
          return; // Stop processing if any image is too large
        }

        newImageURIs.push(asset.uri);
      }

      // if (!result.canceled) {
      // const newImages = result.assets.map(asset => asset.uri);
      const totalImages = [...currentImages, ...newImageURIs];

      // Limit selection to a maximum of 3 images
      if (totalImages.length > MAX_IMAGES) {
        // alert("You can only select up to 3 images.");
        setErrorMessage(`You can only select up to ${MAX_IMAGES} images.`);
        setIsErrorCompVisible(true);
        setImages(currentImages); // Keep the previous state unchanged
      } else {
        setImages(totalImages);
      }
      // }
      // return result.canceled ? null : result.assets[0].uri;
    } catch (error) {
      //console.error('Error picking image:', error);
    } finally {
      setIsLoading(false); // Set isLoading to false after image selection
    }
  };

  const handleCloseModal = () => {
    setIsSuccessAlertCompVisible(false);
    //navigate.replace('log_in');
    // navigate.push('log_in')
    navigate.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "log_in" }], // Replace with the actual login screen name
      }),
    );
  };

  const validateSingleWord = (text) => {
    if (!text) return "";
    return text.replace(/\s/g, ""); // Remove all spaces
  };

  const handleWord1 = (text) => {
    const word1 = validateSingleWord(text);
    setWord1(word1);
  };
  const handleWord2 = (text) => {
    const word2 = validateSingleWord(text);
    setWord2(word2);
  };
  const handleWord3 = (text) => {
    const word3 = validateSingleWord(text);
    setWord3(word3);
  };
  const handleBioComment = (text) => {
    ////console.log('bio comment', text)
    setBio(text);
  };
  const handleSocialAccountForm = (text) => {
    ////console.log('SocialAcct', text)
    setSocialAccount(text);
  };

  const handleChangeImage = async (index) => {
    ////console.log('index', index)
    try {
      //setIsLoading4(true)
      setIsLoading4((prev) => {
        const newLoadingState = [...prev];
        newLoadingState[index] = true;
        return newLoadingState;
      });

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: true,
        aspect: [4, 4],
        quality: 1,
        //selectionLimit: 4 - images.length
      });

      if (!result.canceled) {
        const imageUri = result.assets[0].uri;

        ////console.log('imageURI', imageUri)

        // Check file size using FileSystem
        const fileInfo = await FileSystem.getInfoAsync(imageUri);
        const fileSizeInMB = fileInfo.size / (1024 * 1024); // convert bytes to MB

        ////console.log(`Image size: ${fileSizeInMB.toFixed(2)} MB`);

        if (fileSizeInMB > 3) {
          setErrorMessage(
            `Image too large: The selected image is ${fileSizeInMB.toFixed(2)} MB. Please choose one below 3MB.`,
          );
          setIsErrorCompVisible(true);
          return; // stop further action
        }

        setImages((prevImages) => {
          const newImages = [...prevImages];
          newImages[index] = imageUri; // Ensure it is just a string
          return newImages;
        });

        // setImages((prevImages) => {
        //     const newImages = [...prevImages];

        //     // Replace the existing image while keeping its _id
        //     newImages[index] = {
        //         _id: prevImages[index]._id, // Preserve the existing image _id
        //         url: imageUri,  // Update the URL with new image
        //     };

        //     return newImages;
        // });
        // setImages((prevImages) => {
        //     ////console.log('prevImages', prevImages)
        //     const newImages = [...prevImages];
        //     ////console.log('newImages', newImages)

        //     // Replace the existing image while keeping its _id
        //     newImages[index] = {
        //         url: imageUri,  // Update the URL with new image
        //     };

        //     return newImages;
        // });
      }
    } catch (error) {
      //console.error('Error picking image:', error);
    } finally {
      // setIsLoading4(false); // Set isLoading to false after image selection
      setIsLoading4((prev) => {
        const newLoadingState = [...prev];
        newLoadingState[index] = false;
        return newLoadingState;
      });
    }
  };

  const prepareImageForUpload = async (imageUri) => {
    try {
      const fileInfo = await FileSystem.getInfoAsync(imageUri);

      if (fileInfo.size && fileInfo.size <= MAX_IMAGE_SIZE_BYTES) {
        // Already under 1MB, return as-is
        ////console.log(`Image is already ${Math.round(fileInfo.size / 1024)} KB`);
        return imageUri;
      }

      ////console.log(`Image too large: ${Math.round(fileInfo.size / 1024)} KB, compressing...`);
      let compressRatio = 0.9;
      let compressed = null;

      while (compressRatio > 0.1) {
        compressed = await ImageManipulator.manipulateAsync(imageUri, [], {
          compress: compressRatio,
          format: ImageManipulator.SaveFormat.JPEG,
        });

        const compressedInfo = await FileSystem.getInfoAsync(compressed.uri);

        if (compressedInfo.size && compressedInfo.size <= MAX_IMAGE_SIZE_BYTES) {
          ////console.log(`Compressed to ${Math.round(compressedInfo.size / 1024)} KB`);
          return compressed.uri;
        }

        compressRatio -= 0.1;
      }

      //console.warn('Could not get image under 1MB. Returning best attempt.');
      return compressed ? compressed.uri : imageUri;
    } catch (error) {
      //console.error('Image compression failed:', error);
      return imageUri; // fallback to original
    }
  };

  const handleUpdateClicked = async () => {
    const words = {
      word1,
      word2,
      word3,
    };

    let userDataObj_v4 = {
      words, // Contains word1, word2, word3
      bio,
      socialAccount,
    };

    ////console.log('userDataObj_v4', userDataObj_v4);

    if (images.length === 0) {
      setErrorMessage("Please select an image");
      setIsErrorCompVisible(true);
      return;
    }

    // Check if images array has fewer than 3 images
    if (images.length < 2) {
      setErrorMessage("You must enter at least 2 images");
      setIsErrorCompVisible(true);
      return;
    }

    setIsUpdateClicked(true);
    ////console.log('COMPLETED')

    try {
      const userDataObject = { ...userDataObj_v3, ...userDataObj_v4 };

      ////console.log('userDataObject', userDataObject)

      const userDataJSON = JSON.stringify(userDataObject);
      const formData = new FormData();
      formData.append("userDataJSON", userDataJSON);
      ////console.log('userDataJSON', userDataJSON)

      // if (images.length > 0) {
      //     for (const image of images) {
      //         const imageUri = image;

      //         const processedUri = await prepareImageForUpload(imageUri);

      //         const uriParts = processedUri.split('.');
      //         const fileType = uriParts[uriParts.length - 1];

      //         formData.append(`images`, {
      //             uri: Platform.OS === 'ios' ? processedUri.replace('file://', '') : processedUri,
      //             type: `image/${fileType}`,
      //             name: `image_${index}.${fileType}`,  // Unique name for each image
      //         });
      //     };
      // }

      if (Array.isArray(images) && images.length > 0) {
        for (let index = 0; index < images.length; index++) {
          const imageUri = images[index];

          // Skip invalid URIs
          if (!imageUri || typeof imageUri !== "string") {
            //console.warn(`Skipping image at index ${index}: invalid URI`, imageUri);
            continue;
          }

          try {
            const processedUri = await prepareImageForUpload(imageUri);

            // Skip if compression failed
            if (!processedUri || typeof processedUri !== "string") {
              //console.warn(`Skipping image at index ${index}: compression returned invalid URI`);
              continue;
            }

            const uriParts = processedUri.split(".");
            const fileType = uriParts[uriParts.length - 1] || "jpg";

            formData.append("images", {
              uri: Platform.OS === "ios" ? processedUri.replace("file://", "") : processedUri,
              type: `image/${fileType}`,
              name: `image_${index}.${fileType}`, // Unique name
            });
          } catch (error) {
            //console.error(`Failed to process image at index ${index}:`, error);
          }
        }
      }

      // Append Profile Photo separately
      if (profilePhoto) {
        const uriParts = profilePhoto.split(".");
        const fileType = uriParts[uriParts.length - 1];

        formData.append("profilePhoto", {
          uri: Platform.OS === "ios" ? profilePhoto.replace("file://", "") : profilePhoto,
          type: `image/${fileType}`,
          name: "profilePhoto", // Ensure a unique namee
        });
      }

      setIsLoading3(true);

      const response = await axios.post("/newUser", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200 || response.status === 201) {
        setSuccessMessage(response.data.message ? response.data.message : "Sign up successful");
        //userDataObj_v3 = {};
        // userDataObj_v4 = {};
        setIsSuccessAlertCompVisible(true);
        // Toast.show({
        //     type: 'success',
        //     text1: 'Success',
        //     text2: "Sign up successfull"
        // })
      } else {
        // //console.error('Unexpected response:', response.data);
        setErrorMessage("Unexpected response");
        setIsErrorCompVisible(true);
        // Toast.show({
        //     type: 'error',
        //     text1: 'Error',
        //     text2: 'Unexpected response',
        // })
      }
    } catch (error) {
      if (error.response) {
        setErrorMessage(error.response.data.message);
        setIsErrorCompVisible(true);
        // Toast.show({
        //     type: 'error',
        //     text1: "Warning",
        //     text2: error.response.data.message,

        // })
      } else if (error.request) {
        setErrorMessage("No response Recieved");
        setIsErrorCompVisible(true);
        // Toast.show({
        //     type: 'error',
        //     text1: 'Warning',
        //     text2: 'No response Recieved',
        // })
      } else {
        setErrorMessage(error.message);
        setIsErrorCompVisible(true);
        // Toast.show({
        //     type: 'error',
        //     text1: 'Error!!!',
        //     text2: error.message,
        // })
      }
    } finally {
      setIsLoading3(false);
    }
  };

  return (
    <View>
      <View style={styles.TopHead}>
        <TouchableOpacity onPress={() => navigate.goBack()}>
          <BackArrow color={Colours.DARKGRAY} />
        </TouchableOpacity>
        <Text style={{ fontSize: 18, color: Colours.DARKGRAY, fontFamily: "Sen-Bold" }}>
          Set up your bio
        </Text>
      </View>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: 200,
          backgroundColor: Colours.LIGHTEST,
        }}
      >
        <View style={styles.profileContainer}>
          {/* <View style={styles.profilesImage}
                >
                    {image ? (
                        <View>
                            <Image source={{ uri: image }} style={styles.userImage2} />

                            {isLoading && (
                                <View style={styles.activityLoader}>
                                    <ActivityIndicator size="small" color={Colours.PRIMARY} />
                                </View>
                            )}
                        </View>
                    ) : (
                        <View>
                            <Image source={require('../../../assets/profile_image_holder.jpg')} style={styles.userImage2} />
                            {isLoading && (
                                <View style={styles.activityLoader}>
                                    <ActivityIndicator size="small" color={Colours.PRIMARY} />
                                </View>
                            )}
                        </View>
                    )}
                    <TouchableOpacity
                        style={styles.button}
                        onPress={() => pickImage(setImage, setIsLoading)}
                    >
                        <Text style={styles.updateBtnTxt}>Change</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={styles.button}
                        onPress={isImageSet}
                    >
                        {isLoadingx ? (
                            <ActivityIndicator size="small" color="white" />
                        ) : (
                            <Text style={styles.updateBtnTxt}>Update</Text>
                        )}
                    </TouchableOpacity>
                </View> */}
          {isLoadingBio ? (
            <View
              style={{ flex: 1, marginTop: "5%", justifyContent: "center", alignItems: "center" }}
            >
              <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
            </View>
          ) : (
            <>
              <TouchableOpacity
                style={[styles.photoViewStyle, isPhotoClicked && styles.focusedBorder]}
                onPress={() => pickMultiImage(setImages, setIsLoading1, images)}
                onPressIn={() => setIsPhotoClicked(true)}
                onPressOut={() => setIsPhotoClicked(false)}
              >
                {isLoading1 ? (
                  <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                    <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
                  </View>
                ) : (
                  <>
                    <Text style={styles.photosTxt}>Photos:</Text>

                    {/* Display Selected Images */}
                    {images && images.length > 0 ? (
                      <FlatList
                        data={images}
                        horizontal
                        keyExtractor={(item, index) => index.toString()}
                        //  keyExtractor={(item) => item._id.toString()}
                        renderItem={({ item, index }) =>
                          isLoading4[index] ? (
                            <View style={styles.imageviewStyle3}>
                              <ActivityIndicator size="small" color={Colours.PRIMARY} />
                            </View>
                          ) : (
                            <TouchableOpacity
                              onPress={() => {
                                handleChangeImage(index);
                              }}
                            >
                              <Image
                                style={styles.imageviewStyle}
                                source={{ uri: item }}
                                // source={{ uri: item?.url }}
                              />
                            </TouchableOpacity>
                          )
                        }
                      />
                    ) : (
                      <Image
                        style={styles.imageviewStyle2}
                        source={require("../../../assets/imagePlaceholder.jpg")}
                      />
                    )}
                  </>
                )}
              </TouchableOpacity>

              <View style={styles.threeformsCont}>
                <Text style={styles.textDescribeTxt}>
                  At least one word that best describes you (e.g. Actor, Songwritter, etc)
                </Text>
                <View style={styles.threeFormsView}>
                  <AppTextInput
                    style={[
                      styles.inputTxt,
                      isFormContainer1Clicked && styles.focusedBorder,
                      //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                    ]}
                    placeholder="One"
                    // keyboardType='numeric'
                    onFocus={() => setIsFormContainer1Clicked(true)}
                    onBlur={() => setIsFormContainer1Clicked(false)}
                    value={word1}
                    onChangeText={(text) => {
                      handleWord1(text);
                    }}
                  />
                  <AppTextInput
                    style={[
                      styles.inputTxt,
                      isFormContainer2Clicked && styles.focusedBorder,
                      //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                    ]}
                    placeholder="Two"
                    // keyboardType='numeric'
                    onFocus={() => setIsFormContainer2Clicked(true)}
                    onBlur={() => setIsFormContainer2Clicked(false)}
                    value={word2}
                    onChangeText={(text) => {
                      handleWord2(text);
                    }}
                  />
                  <AppTextInput
                    style={[
                      styles.inputTxt,
                      isFormContainer3Clicked && styles.focusedBorder,
                      //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                    ]}
                    placeholder="Three"
                    // keyboardType='numeric'
                    onFocus={() => setIsFormContainer3Clicked(true)}
                    onBlur={() => setIsFormContainer3Clicked(false)}
                    value={word3}
                    onChangeText={(text) => {
                      handleWord3(text);
                    }}
                  />
                </View>
              </View>
              <View style={styles.discribeCont}>
                <Text style={styles.textDescribeTxt}>A short Bio.</Text>
                <AppTextInput
                  style={[styles.commentBox2, isBioBoxClicked && styles.focusedBorder]}
                  placeholder="Bio:"
                  numberOfLines={6}
                  multiline
                  onFocus={() => setIsBioBoxClicked(true)}
                  onBlur={() => setIsBioBoxClicked(false)}
                  value={bio}
                  textAlignVertical="top"
                  maxLength={200}
                  onChangeText={handleBioComment}
                />
              </View>

              <View style={styles.socialAccountCont}>
                <Text style={styles.textDescribeTxt}>
                  One other social account of yours (e.g. Facebook, Instagram, etc)
                </Text>
                <View style={styles.socialaccountView}>
                  <AppTextInput
                    style={[
                      styles.inputTxt,
                      isSocialAccountForm && styles.focusedBorder,
                      //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                    ]}
                    placeholder="social account"
                    // keyboardType='numeric'
                    onFocus={() => setIsSocialAccountForm(true)}
                    onBlur={() => setIsSocialAccountForm(false)}
                    value={socialAccount}
                    onChangeText={(text) => {
                      handleSocialAccountForm(text);
                    }}
                  />
                </View>
              </View>

              <TouchableOpacity
                style={[
                  styles.greyButton2,

                  {
                    backgroundColor: isUpdateClicked ? Colours.PRIMARY : Colours.DARKGRAY,
                  },
                ]}
                onPress={handleUpdateClicked}
              >
                {isLoading3 ? (
                  <ActivityIndicator size="small" color="white" />
                ) : (
                  <Text style={styles.updateProfileTxt}>Complete sign up</Text>
                )}
              </TouchableOpacity>
            </>
          )}
        </View>
      </ScrollView>

      <Modal visible={isSuccessAlertCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp message={successMessage} onClose={handleCloseModal} />
      </Modal>
      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      <Toast config={toastConfig} />
    </View>
  );
};

const styles = StyleSheet.create({
  TopHead: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingTop: dynamicSpacing(50),
    padding: dynamicSpacing(15),
    gap: dynamicSize(15),
  },
  profileContainer: {
    display: "flex",
    width: "100%",
    padding: dynamicSpacing(15),
  },
  updateBtnTxt: {
    fontSize: dynamicFontSize(15),
    color: "white",
    fontFamily: "Sen-Regular",
  },
  photosTxt: {
    marginRight: dynamicSpacing(100),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  textDescribeTxt: {
    paddingBottom: dynamicSpacing(15),
    fontSize: dynamicFontSize(13),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
  },
  imageviewStyle: {
    width: dynamicSize(45),
    height: dynamicSize(40),
    borderRadius: dynamicSize(10),
    marginLeft: dynamicSpacing(5),
  },
  imageviewStyle2: {
    width: dynamicSize(45),
    height: dynamicSize(40),
    borderRadius: dynamicSize(10),
  },
  viewProfileTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },
  updateProfileTxt: {
    fontSize: dynamicFontSize(15),
    color: "white",
    fontFamily: "Sen-Bold",
  },
  viewPublicProfile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: dynamicSpacing(20),
    gap: dynamicSpacing(5),
  },
  threeformsCont: {
    display: "flex",
    width: "100%",
    borderRadius: dynamicSize(10),
    backgroundColor: "white",
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
  },
  socialAccountCont: {
    display: "flex",
    width: "100%",
    borderRadius: dynamicSize(10),
    backgroundColor: "white",
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
  },
  imageviewStyle3: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: dynamicSize(45),
    height: dynamicSize(40),
    borderRadius: dynamicSize(10),
    marginLeft: dynamicSpacing(5),
  },
  profilesImage: {
    display: "flex",
    padding: dynamicSpacing(15),
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderRadius: dynamicSize(10),
    gap: dynamicSpacing(15),
  },
  threeFormsView: {
    display: "flex",
  },
  socialaccountView: {
    display: "flex",
  },
  userImage2: {
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(99),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.PRIMARY,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(10),
    width: dynamicSize(100),
    height: dynamicSize(40),
    backgroundColor: Colours.PRIMARY,
  },
  activityLoader: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(99),
    backgroundColor: "rgb(253, 252, 252)",
  },
  inputTxt: {
    height: dynamicSize(40),
    width: dynamicSize(250),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(10),
    marginRight: dynamicSpacing(10),
  },
  photoViewStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: dynamicSize(60),
    width: "100%",
    marginTop: dynamicSpacing(15),
    paddingLeft: dynamicSpacing(10),
    paddingRight: dynamicSpacing(10),
    borderWidth: dynamicSize(2),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
  },
  discribeCont: {
    display: "flex",
    width: "100%",
    borderRadius: dynamicSize(10),
    backgroundColor: "white",
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
  },
  commentBox2: {
    height: dynamicSize(70),
    width: "100%",
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(2),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(5),
  },
  greyButton2: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(20),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
});

export default UserBioSettingUp;
